import React from "react";
import styled from "styled-components";
import { Container } from "react-bootstrap";

const Section = styled.section`
  padding: 48px 0;
  background: var(--nd-black);
`;

const Kicker = styled.p`
  font-family: 'Space Mono', monospace;
  font-size: 11px;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--nd-text-secondary);
  margin: 0 0 12px;
`;

const Heading = styled.h2`
  font-family: 'Space Grotesk', sans-serif;
  font-size: 24px;
  font-weight: 500;
  color: var(--nd-text-display);
  margin: 0 0 24px;
`;

const Frame = styled.div`
  position: relative;
  width: 100%;
  padding-bottom: 56.25%; /* 16:9 */
  background: var(--nd-surface);
  border: 1px solid var(--nd-border-visible);
  border-radius: 8px;
  overflow: hidden;
`;

const Iframe = styled.iframe`
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  border: 0;
`;

const SampleVideo = ({ url, title, onPlay }) => (
  <Section>
    <Container>
      <Kicker>FREE PREVIEW</Kicker>
      <Heading>Sample lesson</Heading>
      <Frame>
        <Iframe
          src={url}
          title={`Sample lesson — ${title}`}
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
          onLoad={onPlay}
        />
      </Frame>
    </Container>
  </Section>
);

export default SampleVideo;
